import React from 'react';
import { Card, CardBody, Col, Collapse, FormGroup, Input, Label, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TermsAccordion = ({
  handleTermsCheckbox,
  handleTermsInput,
  index,
  isLast,
  isRequired,
  term,
  title,
  toggleAccordion
}) => {
  if (!term) {
    return null;
  }

  let panelStyle = 'panel-collapse';
  if (index === 0) {
    panelStyle += ' panel-collapse-first';
  } else if (isLast) {
    panelStyle += ' panel-collapse-last';
  }

  const { active, isOpen, termText, termTitle } = term;

  return (
    <div className={panelStyle}>
      <Row className="ml-0 d-flex justify-content-between">
        <Col xs={11}>
          <FormGroup className="mb-0">
            <Input
              id={`terms-checkbox-${term.id}`}
              checked={active}
              disabled={isRequired}
              onChange={() => handleTermsCheckbox(index)}
              type="checkbox"
            />
            <h3 className="text-transform-unset" onClick={() => toggleAccordion(index)} onKeyDown={() => toggleAccordion(index)}>
              {title}
            </h3>
          </FormGroup>
        </Col>
        <Col
          className="align-right"
          onClick={() => toggleAccordion(index)}
          onKeyDown={() => toggleAccordion(index)}
          tabIndex="0"
          role="button"
        >
          <FontAwesomeIcon icon={isOpen ? 'chevron-circle-up' : 'chevron-circle-down'} />
        </Col>
      </Row>

      <Collapse isOpen={isOpen}>
        <Card className="px-1">
          <CardBody>
            <FormGroup>
              <Label className="font-weight-bold" for="termTitle">
                Display Title
              </Label>
              <Input
                id="termTitle"
                maxLength="150"
                onChange={e => handleTermsInput(e, index)}
                value={termTitle}
              />
            </FormGroup>

            <FormGroup>
              <Label className="font-weight-bold" for="termText">
                Text
              </Label>
              <Input
                id="termText"
                type="textarea"
                onChange={e => handleTermsInput(e, index)}
                rows="4"
                value={termText}
              />
            </FormGroup>
          </CardBody>
        </Card>
      </Collapse>
    </div>
  );
};

export default TermsAccordion;
